import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate, Redirect } from 'react-router-dom';
import { FiEye } from "react-icons/fi"
import { FaRegEyeSlash } from "react-icons/fa"
import { AiFillEyeInvisible } from "react-icons/ai";
// import { useToasts } from "react-toast-notifications"
import { auth_user, getAppsConfig, getUserInfo } from '../../services/http';
import { toast } from 'react-toastify';
import ProcessSpinner from '../../components/ProcessSpinner/ProcessSpinner';
import { CDN_BASE_URL } from '../../constants/constants';




const Authentication = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const states = useSelector((state) => state, shallowEqual);

  const [processOngoing, setProcessOngoing] = useState(false)
  
  const [appName, setAppName] = useState("Supervison TEG BCC")
  const [appBackgroundImg, setAppBackgroundImg] = useState(null)
  
  const [credentials, setCredentials] = useState({ username: "", password: "" });

  const [dataLoading, setDataLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    console.log("1", states.userInfo)
    console.log("2", states.userToken)
    if (Object.keys(states.userInfo).length == !0 && Object.keys(states.userToken).length !== 0) {
      navigate("/dashboard")
    } else {
      navigate("/auth")
    }
  }, [states.userInfo, states.userToken])
  


  const handleSubmitCredentials = async (e) => {
    setProcessOngoing(true)
    e.preventDefault()
    console.log("Credentials are ", credentials)

if(credentials.username === "" || credentials.password === "") {
  toast.error("Veuillez remplir tous les champs.", {
    position: toast.POSITION.TOP_RIGHT,
    className: 'rotateY animated'
  });
  setProcessOngoing(false)
 
} else {



    //   Start
    const auth_response = await auth_user(credentials);
    setDataLoading(true);
    console.log("auth_response ", auth_response)
    if (auth_response && auth_response.status !== 200) {
      console.log("Bad response is --- ", auth_response.response.data.message)
      setTimeout(() => {
        setDataLoading(false)
      }, 500);
      var errorMsg;
      setProcessOngoing(false)

     if(auth_response.response.status === 422) {
      errorMsg = "Vos informations de connexion sont incorrectes."

     } else {

       if (auth_response.response) { 
         errorMsg = auth_response.response.data.message 
       } else { 
         errorMsg = "Erreur de  connexion au serveur." 
       }
     }
console.log("error MSG ", errorMsg)
      // if(auth_response.response)
      toast.error(errorMsg, {
        position: toast.POSITION.TOP_RIGHT,
        className: 'rotateY animated'
      });

    } else if (auth_response && auth_response.status === 200) {
      setDataLoading(true);
      // setProcessOngoing(false)
      console.log("Good response is --- ", auth_response)
      dispatch({
        type: "SET",
        key: "userToken",
        payload: auth_response.data,
      });
      toast.success("Connexion Réussie.", {
        position: toast.POSITION.TOP_RIGHT,
        className: 'rotateY animated'
      });
      console.log(auth_response.data.access_token)
      var tokenGenerated = auth_response.data
      const user_connected_data = await getUserInfo(tokenGenerated.access_token)
      console.log("userInfo ", user_connected_data)
      dispatch({
        type: "SET",
        key: "userInfo",
        payload: user_connected_data.data,
      });

      const newData = []
      const temp = {}
      console.log(user_connected_data)
      user_connected_data.data?.roles?.map(elt => {
        elt.permissions?.map(item => {

          newData.push(item)
        }

        )
      })
     newData.map(value => (
        temp[`${value.name}`] = value.name
      ))

      dispatch({
        type: "SET",
        key: "userPermissions",
        payload: temp,
      });


      console.log(states.userPermissions)
      setTimeout(() => {
        setDataLoading(false)
      }, 2000);

      navigate("/")
    }
    }



    // End
  }

  const handleDisplayPassword = () => {
    if (showPassword === true) {
      setShowPassword(false)
    } else {
      setShowPassword(true)
    }
  }


  const handleInputChange = (e, key) => {
    const value = e.currentTarget.value;
    if (key === "password") {
      setCredentials({ ...credentials, password: value })
    }
    if (key === "username") {
      setCredentials({ ...credentials, username: value })
    }
  }

  useEffect(() => {
    if(window.location.pathname !== "/auth") {
        navigate("/auth")
     }
  }, [])
  const getAppliParams = async () => {
    let request = await getAppsConfig();
    if(request.response && request.response.status !== 200){
        console.log(request.response)
    } else {
        console.log("navbar app name ", request)
        setAppName(request.data.applicationInterface.application_name)
        setAppBackgroundImg(request.data.applicationInterface.background_image)
    }
}
useEffect(() => {
getAppliParams();
}, [])


  return (

    <div class="form-container">
      <div class="form-form">
        <div class="form-form-wrap">
          <div class="form-container">
            <div class="form-content" style={{ paddingTop: "50%" }}>

              <h1 class="">Connexion
                {/* <a href="index.html"><span class="brand-name">Supervision BCC</span></a> */}
              </h1>
              <p class="signup-link"></p>
              {/* <p class="signup-link">Nouveau ? <a href="auth_register.html">Créer un compte</a></p> */}

              <form class="text-left">
                <div class="form">

                  <div id="username-field" class="field-wrapper input">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" margin-left="15px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    <input id="username" value={credentials.username} onChange={(e) => handleInputChange(e, "username")} name="username" type="text" class="form-control custom-form-control" placeholder="Nom d'utilisateur" />
                  </div>

                  <div id="password-field" class="field-wrapper input pb-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                    <input id="password" value={credentials.password} onChange={(e) => handleInputChange(e, "password")} name="password" type={showPassword === true ? "text" : "password"} class="form-control custom-form-control" placeholder="Mot de passe" />
                    {showPassword === false && <AiFillEyeInvisible onClick={handleDisplayPassword} style={{ width: 20, height: 20, marginLeft: -30, marginTop: 3, cursor: 'pointer' }} />}

                    {showPassword === true && <FiEye onClick={handleDisplayPassword} style={{ width: 20, height: 20, marginLeft: -30, marginTop: 3, cursor: 'pointer' }} />}

                  </div>
                  <div class="d-sm-flex justify-content-between">
                    <div class="field-wrapper toggle-pass pb-3">
                      <p class="d-inline-block"><div onClick={() => navigate("/password-forgotten")} class="forgot-pass-link">Mot de passe oublié ?</div></p>

                    </div>

                  </div>

                  <div class="field-wrapper text-right d-flex justify-content-end">
                    {processOngoing == false ? <button disabled={dataLoading} onClick={(e) => handleSubmitCredentials(e)} class="btn btn-primary d-flex align-self-end">
                      {/* {dataLoading === true && <span class="spinner-border text-white mr-2 pb-2 custom-spinner-auth "></span>} */}
                      <span className="">Se connecter</span>
                    </button> :
                    <ProcessSpinner />}
                  </div>

                  <div class="field-wrapper text-center keep-logged-in">

                  </div>

                </div>
              </form>
              <p class="terms-conditions" style={{ marginTop: 0 }}><span style={{color: '#256CE2', fontWeight: 'bold'}}>
                Supervision du TEG  
                {/* {appName} */}
                 </span> © 2022 Tous droits réservés</p>

            </div>
          </div>
        </div>
      </div>
      <div class="form-image">
        {/* {appBackgroundImg !== null ? <div class="l-image"
        style={{backgroundImage: `url(${CDN_BASE_URL}${appBackgroundImg})`}}
        >
        </div> :  */}
        <div class="l-image"
        >
        </div>
        {/* } */}
      </div>
    </div>
  )
}

export default Authentication